const sponsorships = [
	{
		path: '/tv/sponsorships/campaigns/list',
		name: 'tv-sponsorships-campaigns-list',
		component: () => import('@/views/tv/sponsorships/campaigns/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGTV,sponsorships',
		},
	},
	{
		path: '/tv/sponsorships/applications/list',
		name: 'tv-sponsorships-applications-list',
		component: () => import('@/views/tv/sponsorships/applications/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGTV,sponsorships',
		},
	},
]

export default sponsorships
